import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRedirectArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconRedirectArrow"><Path d="M12 20.25V7.875C12 5.59683 10.1532 3.75 7.875 3.75C5.59683 3.75 3.75 5.59683 3.75 7.875C3.75 10.1532 5.59683 12 7.875 12H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M16.75 8.5L20.25 12L16.75 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconRedirectArrow;
